"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = __importDefault(require("classnames"));
var Title_1 = __importDefault(require("../Title"));
function ExtraCarsList(props) {
    var title = props.title, cars = props.cars, Item = props.Item, className = props.className, style = props.style;
    if (!(cars === null || cars === void 0 ? void 0 : cars.length)) {
        return null;
    }
    return (react_1.default.createElement("section", { style: style, className: classnames_1.default(className, 'aui-CarsRelated') },
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement(Title_1.default, { level: "h2" }, title),
            react_1.default.createElement("div", { className: "row" }, cars.map(function (car) { return (react_1.default.createElement(Item, { car: car, key: car.id })); })))));
}
exports.default = ExtraCarsList;
ExtraCarsList.displayName = 'ExtraCarsList';
ExtraCarsList.propTypes = {
    className: prop_types_1.default.string,
    style: prop_types_1.default.object,
    title: prop_types_1.default.string,
    cars: prop_types_1.default.array,
    Item: prop_types_1.default.elementType.isRequired,
};
